export default "<button mat-button class=\"button\">\n  <ng-content></ng-content>\n</button>\n"